import SellerData, { mapDispatchToProps, mapStateToProps } from '../../../../../pages/vip/features/seller-data/index';

export default SellerData;

export { mapDispatchToProps, mapStateToProps };
